import { render } from "./ReportsSubCountyZonesDetails.vue?vue&type=template&id=0c87336f&scoped=true"
import script from "./ReportsSubCountyZonesDetails.vue?vue&type=script&lang=js"
export * from "./ReportsSubCountyZonesDetails.vue?vue&type=script&lang=js"

import "./ReportsSubCountyZonesDetails.vue?vue&type=style&index=0&id=0c87336f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c87336f"]])

export default __exports__